export default __webpack_public_path__ + "static/media/pic3.3ca2e7aa.jpg";